<template>
<app-bar></app-bar>
<div>

    <!-- HERO SECTION -->
    <section class="contact-hero">
        <div class="hero-overlay"></div>

        <v-container class="hero-content">
            <v-card class="hero-card" elevation="12">
                <v-card-text class="hero-flex">

                    <!-- LEFT TEXT -->
                    <div class="hero-text">
                        <h1 class="hero-title">{{ $t('Hero.Title') }}</h1>
                        <p class="hero-subtitle">{{ $t('Hero.Subtitle') }}</p>
                    </div>

                    <!-- RIGHT IMAGE SHAPE -->
                    <div class="hero-image-wrapper">
                        <div class="hero-image-shape">
                            <img :src="comImage" :alt="$t('Hero.Title')" loading="lazy" />
                        </div>
                    </div>

                </v-card-text>
            </v-card>
        </v-container>
    </section>

    <!-- CONTACT INFO & MESSAGE -->
    <section class="contact-main">
        <v-container>
            <v-row justify="space-between" align="stretch" dense class="contact-info-row">

                <!-- LEFT MESSAGE -->
                <v-col cols="12" md="6" class="contact-message">
                    <div class="message-wrapper">
                        <h2 class="message-title">{{ $t('ContactMessage.Title') }}</h2>
                        <p class="message-text">{{ $t('ContactMessage.Text') }}</p>
                        <p class="message-text email-line">
                            <v-icon color="green darken-2" class="mr-2" size="40">mdi-email</v-icon>
                            <strong>{{ $t('ContactMessage.EmailLabel') }}</strong> {{ address.email }}
                        </p>
                    </div>
                </v-col>

                <!-- RIGHT ADDRESS INFO -->
                <v-col cols="12" md="5">
                    <v-card class="info-card" elevation="0">
                        <v-card-text>
                            <h2 class="form-title gradient-title">{{ $t('ContactInfoPage.AddressTitle') }}</h2>
                            <div class="info-item">
                                <v-icon left color="green darken-2">mdi-office-building</v-icon>
                                <span>{{ $t('ContactInfoPage.CompanyName') }}</span>
                            </div>
                            <div class="info-item">
                                <v-icon left color="green darken-2">mdi-map-marker</v-icon>
                                <span>{{ address.location }} {{ address.city }}</span>
                            </div>
                            <div class="info-item">
                                <v-icon left color="green darken-2">mdi-phone</v-icon>
                                <span>+{{ address.phone }}</span>
                            </div>
                            <div class="info-item">
                                <v-icon left color="green darken-2">mdi-clock-outline</v-icon>
                                <span>{{ $t('ContactInfoPage.WorkingHours') }}</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>
        </v-container>
    </section>

    <!-- CONTACT FORM -->
    <section class="contact-form-section" id="contact-form">
        <v-container>
            <v-card class="contact-card" elevation="0">
                <v-card-text>
                    <h2 class="site-title text-center mb-6">{{ $t('ContactForm.Title') }}</h2>

                    <v-form ref="contactForm" v-model="formValid" @submit.prevent="submitForm">
                        <v-row dense>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.name" :label="$t('ContactForm.NameLabel')" :rules="[v => !!v || $t('ContactForm.NameRequired')]" variant="outlined" required></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.email" :label="$t('ContactForm.EmailLabel')" :rules="[
                      v => !!v || $t('ContactForm.EmailRequired'),
                      v => /.+@.+\..+/.test(v) || $t('ContactForm.EmailInvalid')
                    ]" variant="outlined" required></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.phone" :label="$t('ContactForm.PhoneLabel')" variant="outlined"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12">
                                <v-textarea v-model="form.message" :label="$t('ContactForm.MessageLabel')" variant="outlined" rows="5" :rules="[v => !!v || $t('ContactForm.MessageRequired')]" required></v-textarea>
                            </v-col>
                        </v-row>

                        <div class="text-center">
                            <v-btn class="btn-design mt-6" large type="submit" rounded :disabled="!formValid">
                                {{ $t('ContactForm.SubmitButton') }}
                                <v-icon right>mdi-send</v-icon>
                            </v-btn>
                        </div>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-container>
    </section>

    <!-- GOOGLE MAP -->
    <section class="contact-map">
        <v-container fluid>
          <iframe class="map-frame" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.1594150176356!2d39.1591094!3d-6.627112499999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c570035f7141f%3A0x4e63ee28e670c3b2!2sMNK%20agriventures%20ltd!5e0!3m2!1sen!2stz!4v1771919189505!5m2!1sen!2stz" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </v-container>
    </section>

</div>
<Footer></Footer>
</template>

<script>
import axios from 'axios';
import AppBar from '../Layout/appBar.vue';
import Footer from '../Layout/Footer.vue';
import heroImage from "@/assets/phn.jpg";
import comImage from "@/assets/tel.jpg";
import swtalert from '@/mixins/swtalert';

export default {
    mixins: [swtalert],
    components: {
        AppBar,
        Footer
    },
    data() {
        return {
            heroImage,
            comImage,
            address: {},
            form: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            },
            formValid: false
        };
    },
    methods: {
        submitForm() {
            const data = {
                ...this.form
            };
            axios
                .post("/contact", data, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include token if needed
                    },
                })
                .then((response) => {
                    this.showAlert(response.data.message, "success");
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                })
                .catch((error) =>
                    this.showAlert(error.response.data.message, "error")
                );
        },
        async loadAddress() {
            try {
                const response = await axios.get("/company-address", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`
                    },
                });

                if (response.data.data) {
                    this.address = {
                        ...response.data.data
                    };
                }
            } catch (error) {
                console.error("Failed to load company address:", error);
                // Optionally show a friendly toast or message
            }
        },

    },
    mounted() {
        this.loadAddress();
    },
};
</script>

<style scoped>
/* HERO SECTION */
/* HERO BACKGROUND */
.contact-hero {
    position: relative;
    padding: 8rem 1rem;
    background: url('@/assets/pilipili g.jpg') center/cover no-repeat;
    overflow: hidden;
    color: #fff;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1;
}

.hero-content {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
}

/* HERO CARD */
.hero-card {
    background: rgba(46, 125, 50, 0.92);
    backdrop-filter: blur(8px);
    border-radius: 24px;
    padding: 3rem;
    max-width: 1150px;
    width: 100%;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
}

.hero-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    flex-wrap: wrap;
}

/* LEFT TEXT */
.hero-text {
    flex: 1 1 320px;
}

.hero-title {
    font-size: 3rem;
    font-weight: 900;
    margin-bottom: 1.5rem;
}

.hero-subtitle {
    font-size: 1.25rem;
    line-height: 1.8;
    max-width: 600px;
    font-weight: 400;
    opacity: 0.95;
    color: white;
    font-style: italic;
}

.hero-btn {
    background: #fff;
    color: #2e7d32;
    font-weight: 700;
    padding: 0.9rem 2rem;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;
}

.hero-btn:hover {
    transform: translateY(-3px);
    background: #f1f8f6;
}

/* RIGHT IMAGE SHAPE */
.hero-image-wrapper {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hero-image-shape {
    width: 220px;
    height: 220px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
    border: 6px solid rgba(255, 255, 255, 0.8);
    transition: transform 0.4s ease;
}

.hero-image-shape:hover {
    transform: scale(1.05);
}

.hero-image-shape img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* RESPONSIVE */
@media (max-width: 960px) {
    .hero-flex {
        flex-direction: column;
        text-align: center;
    }

    .hero-title {
        font-size: 2.3rem;
    }

    .hero-subtitle {
        font-size: 1.1rem;
        max-width: 100%;
    }

    .hero-image-shape {
        width: 180px;
        height: 180px;
        margin-top: 1.5rem;
    }
}

@media (max-width: 600px) {
    .hero-card {
        padding: 2rem;
    }

    .hero-title {
        font-size: 1.9rem;
    }

    .hero-subtitle {
        font-size: 1rem;
    }

    .hero-image-shape {
        width: 140px;
        height: 140px;
    }
}

/* CONTACT MAIN */
.contact-main {
    padding: 6rem 1rem;
}

.contact-info-row {
    align-items: center;
}

.contact-message {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.message-wrapper {
    max-width: 420px;
}

.message-title {
    font-size: 2.2rem;
    font-weight: 800;
    color: #2e7d32;
    margin-bottom: 1.2rem;
}

.message-text {
    font-size: 1.1rem;
    color: #444;
    margin-bottom: 1rem;
    line-height: 1.6;
}

.email-line {
    display: flex;
    align-items: center;
}

/* INFO CARD */
.info-card {
    border-radius: 20px;
    padding: 2rem;
    background: linear-gradient(135deg, #e8f5e9, #f1f8f6, #ffffff);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.info-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
}

.gradient-title {
    font-size: 2rem;
    font-weight: 800;
    background: linear-gradient(135deg, #2e7d32, #4caf50, #b2f8b6);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 2rem;
}

.info-item {
    display: flex;
    align-items: center;
    font-size: 1rem;
    margin-bottom: 0.5rem;
    color: #444;
}

/* CONTACT FORM */
.contact-form-section {
    margin-top: -6rem;
    z-index: 5;
    position: relative;
}

.contact-card {
    border-radius: 20px;
    padding: 3rem;
    background-color: #ffffff;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.contact-card:hover {
    transform: translateY(-4px);
}

/* MAP */
.contact-map {
    margin-top: 6rem;
}

.map-frame {
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
}

/* RESPONSIVE */
@media (max-width: 960px) {
    .contact-main {
        padding: 4rem 1rem;
    }

    .contact-form-section {
        margin-top: -3rem;
    }
}

@media (max-width: 600px) {

    .hero-subtitle {
        font-size: 1rem;
    }

    .contact-card,
    .info-card {
        padding: 2rem;
    }
}
</style>
